import { type Company } from '@tmdb-graphql-api/schema/types';
import { encode } from 'js-base64';
import { type CompanyOption } from '../types.ts';

export const buildDependencyKey = (values: Company[] | CompanyOption[] | undefined) => {
  if (!values || values.length === 0) {
    return '';
  }

  return encode(values.map(value => value.id).join(','));
};
